function initVGSpy() {
	[... document.querySelectorAll('[data-vgspy]')].forEach(el => {
		new vg.VGSpy(el);
	})
}

export default initVGSpy
